export default {
  lang: {
    num: 'Hindi.',
    total: 'Artikulo/Total',
    strip: 'Artikulo',
    more: 'Mas maramin',
    chosen: 'Pinilin',
    cancel: 'Undelect',
    bulkOperations: 'Operasyon ng batch',
    import: 'Importan',
  },
};
